import proj4 from 'proj4';
import { register } from 'ol/proj/proj4';

proj4.defs(
  'EPSG:2154',
  '+proj=lcc +lat_1=49 +lat_2=44 +lat_0=46.5 +lon_0=3 ' +
    '+x_0=700000 +y_0=6600000 +ellps=GRS80 ' +
    '+towgs84=0,0,0,0,0,0,0 +units=m +no_defs',
);
proj4.defs(
  'EPSG:2969',
  '+proj=utm +zone=20 +ellps=intl +towgs84=137,248,-430,0,0,0,0 +units=m +no_defs',
);
proj4.defs('EPSG:2970', '+proj=utm +zone=20 +ellps=intl +units=m +no_defs');
proj4.defs(
  'EPSG:2971',
  '+proj=utm +zone=22 +ellps=intl +towgs84=-186,230,110,0,0,0,0 +units=m +no_defs',
);
proj4.defs(
  'EPSG:2972',
  '+proj=utm +zone=22 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs +type=crs',
);
proj4.defs('EPSG:2973', '+proj=utm +zone=20 +ellps=intl +units=m +no_defs');
proj4.defs(
  'EPSG:2975',
  '+proj=utm +zone=40 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs',
);
proj4.defs(
  'EPSG:4139',
  '+title=Puerto Rico EPSG:4139 (3 param datum shift) +proj=longlat +towgs84 = 11,72,-101,0,0,0,0 +a=6378206.4 +b=6356583.8',
);
proj4.defs(
  'EPSG:4181',
  '+title=Luxembourg 1930 EPSG:4181 (7 param datum shift) +proj=longlat +towgs84=-193,13.7,-39.3,-0.41,-2.933,2.688,0.43 +a=6378388.0, +b=6356911.94612795',
);
proj4.defs(
  'EPSG:4272',
  '+title=NZGD49 +proj=longlat +ellps=intl +datum=nzgd49 +no_defs ',
);
proj4.defs(
  'EPSG:4302',
  '+title=Trinidad 1903 EPSG:4302 (7 param datum shift) +proj=longlat +a=6378293.63683822 +b=6356617.979337744 +towgs84=-61.702,284.488,472.052,0,0,0,0',
);
proj4.defs('EPSG:4466', '+proj=longlat +ellps=GRS80 +no_defs +type=crs');
proj4.defs(
  'EPSG:4471',
  '+proj=utm +zone=38 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs +type=crs',
);
proj4.defs(
  'EPSG:4970',
  '+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs',
);
proj4.defs(
  'EPSG:21781',
  '+title=CH1903 / LV03 +proj=somerc +lat_0=46.95240555555556 +lon_0=7.439583333333333 +x_0=600000 +y_0=200000 +ellps=bessel +towgs84=674.374,15.056,405.346,0,0,0,0 +units=m +no_defs',
);
proj4.defs(
  'EPSG:26591',
  '+title= Monte Mario (Rome) / Italy zone 1 EPSG:26591 +proj=tmerc +lat_0=0 +lon_0=-3.45233333333333 +from_greenwich=12.45233333333333 +k=0.999600 +x_0=1500000 +y_0=0 +a=6378388.0, +b=6356911.94612795 +units=m',
);
proj4.defs(
  'EPSG26912',
  '+title=NAD83 / UTM zone 12N +proj=utm +zone=12 +a=6378137.0 +b=6356752.3141403',
);
proj4.defs(
  'EPSG:27200',
  '+title=New Zealand Map Grid +proj=nzmg +lat_0=-41 +lon_0=173 +x_0=2510000 +y_0=6023150 +ellps=intl +datum=nzgd49 +units=m +no_defs',
);
proj4.defs(
  'EPSG:27563',
  '+title=NTF (Paris)/Lambert Sud France +proj=lcc +lat_1=44.10000000000001 +lat_0=44.10000000000001 +lon_0=0 +k_0=0.9998774990000001 +x_0=600000 +y_0=200000 +a=6378249.2 +b=6356515 +towgs84=-168,-60,320,0,0,0,0 +pm=paris +units=m +no_defs ',
);
proj4.defs(
  'EPSG:41001',
  '+title=simple mercator EPSG:41001 +proj=merc +lat_ts=0 +lon_0=0 +k=1.000000 +x_0=0 +y_0=0 +ellps=WGS84 +datum=WGS84 +units=m',
);
proj4.defs(
  'EPSG:42304',
  '+title=Atlas of Canada, LCC +proj=lcc +lat_1=49 +lat_2=77 +lat_0=49 +lon_0=-95 +x_0=0 +y_0=0 +ellps=GRS80 +datum=NAD83 +units=m +no_defs',
);
proj4.defs(
  'EPSG:102757',
  '+title=NAD 1983 StatePlane Wyoming West Central FIPS 4903 Feet +proj=tmerc +lat_0=40.5 +lon_0=-108.75 +x_0=600000.0 +y_0=0 +k=0.999938 +a=6378137.0  +b=6356752.3141403 +to_meter=0.3048006096012192',
);
proj4.defs(
  'EPSG:102758',
  '+title=NAD 1983 StatePlane Wyoming West FIPS 4904 Feet +proj=tmerc +lat_0=40.5  +lon_0=-110.0833333333333 +x_0=800000  +y_0=100000  +k=0.999938 +a=6378137.0 +b=6356752.3141403 +to_meter=0.3048006096012192',
);

// Alias
proj4.defs(
  'http://www.opengis.net/gml/srs/epsg.xml#2154',
  proj4.defs('EPSG:2154'),
);
proj4.defs(
  'http://www.opengis.net/gml/srs/epsg.xml#2969',
  proj4.defs('EPSG:2969'),
);
proj4.defs(
  'http://www.opengis.net/gml/srs/epsg.xml#2970',
  proj4.defs('EPSG:2970'),
);
proj4.defs(
  'http://www.opengis.net/gml/srs/epsg.xml#2971',
  proj4.defs('EPSG:2971'),
);
proj4.defs(
  'http://www.opengis.net/gml/srs/epsg.xml#2972',
  proj4.defs('EPSG:2972'),
);
proj4.defs(
  'http://www.opengis.net/gml/srs/epsg.xml#2973',
  proj4.defs('EPSG:2973'),
);
proj4.defs(
  'http://www.opengis.net/gml/srs/epsg.xml#2975',
  proj4.defs('EPSG:2975'),
);
proj4.defs(
  'http://www.opengis.net/gml/srs/epsg.xml#4139',
  proj4.defs('EPSG:4139'),
);
proj4.defs(
  'http://www.opengis.net/gml/srs/epsg.xml#4181',
  proj4.defs('EPSG:4181'),
);
proj4.defs(
  'http://www.opengis.net/gml/srs/epsg.xml#4272',
  proj4.defs('EPSG:4272'),
);
proj4.defs(
  'http://www.opengis.net/gml/srs/epsg.xml#4302',
  proj4.defs('EPSG:4302'),
);
proj4.defs(
  'http://www.opengis.net/gml/srs/epsg.xml#4326',
  proj4.defs('EPSG:4326'),
);
proj4.defs(
  'http://www.opengis.net/gml/srs/epsg.xml#4466',
  proj4.defs('EPSG:4466'),
);
proj4.defs(
  'http://www.opengis.net/gml/srs/epsg.xml#4471',
  proj4.defs('EPSG:4471'),
);
proj4.defs(
  'http://www.opengis.net/gml/srs/epsg.xml#4970',
  proj4.defs('EPSG:4970'),
);
proj4.defs(
  'http://www.opengis.net/gml/srs/epsg.xml#E1781',
  proj4.defs('EPSG:21781'),
);
proj4.defs(
  'http://www.opengis.net/gml/srs/epsg.xml#E6591',
  proj4.defs('EPSG:26591'),
);
proj4.defs(
  'http://www.opengis.net/gml/srs/epsg.xml#E7200',
  proj4.defs('EPSG:27200'),
);
proj4.defs(
  'http://www.opengis.net/gml/srs/epsg.xml#E7563',
  proj4.defs('EPSG:27563'),
);
proj4.defs(
  'http://www.opengis.net/gml/srs/epsg.xml#E1001',
  proj4.defs('EPSG:41001'),
);
proj4.defs(
  'http://www.opengis.net/gml/srs/epsg.xml#E2304',
  proj4.defs('EPSG:42304'),
);
proj4.defs(
  'http://www.opengis.net/gml/srs/epsg.xml#EP2757',
  proj4.defs('EPSG:102757'),
);
proj4.defs(
  'http://www.opengis.net/gml/srs/epsg.xml#EP2758',
  proj4.defs('EPSG:102758'),
);

register(proj4);
